export enum Status {
  Approved = "Approved",
  DraftNew = "DraftNew",
  DraftEdit = "DraftEdit",
}
